import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { getSingleTemplate } from '../../core/_request'
import { useNavigate } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'

export const Preview = ({
  previewTemplateId,
  prevStep,
  templateData,
  setTemplateData
}: {
  previewTemplateId: any
  prevStep: () => void
  templateData: any
  setTemplateData: any
}) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const getSingleTemplateData = async (templateId: any) => {
    try {
      const {
        data: { data, success, errors },
      } = await getSingleTemplate(templateId)
      if (success) {
        setTemplateData(data)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (previewTemplateId) {
      getSingleTemplateData(previewTemplateId)
    }
  }, [previewTemplateId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className='col-12 row'>
      <div className=' col-12 border rounded  p-6'>
        <div className='col-12'>
          <div className='d-flex justify-content-between pb-3'>
            <p className='align-self-md-center  mb-0'>Subject: {templateData?.subject}</p>
            <div>
              <button
                type='button'
                className='btn btn-primary'
                onClick={() => {
                  prevStep()
                  navigate(`/updates/create-template/${previewTemplateId}`)
                }}
              >
                {formatMessage({ id: 'Edit' })}
              </button>
            </div>
          </div>
          <div>
            <div dangerouslySetInnerHTML={{ __html: templateData?.body }}></div>
            <div dangerouslySetInnerHTML={{ __html: templateData?.footer }}></div>
          </div>

          <div className='d-flex gap-4 mt-4'>
            {templateData &&
              templateData?.files?.length > 0 &&
              templateData?.files?.map((file: any) => {
                return (
                  <div key={file?.fileId} className='d-flex gap-3'>
                    <div>
                      {file?.name.split('.').pop() === 'pdf' ? (
                        <img
                          alt=''
                          className='w-30px me-3'
                          src={toAbsoluteUrl('/media/icons/file_extensions/pdf.svg')}
                        />
                      ) : (
                        <img
                          alt=''
                          className='w-30px me-3'
                          src={toAbsoluteUrl('/media/svg/files/blank-image.svg')}
                        />
                      )}
                    </div>
                    <p className='m-0'>{file?.name}</p>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </div>
  )
}
